import pulpWhiteLogo from '@assets/logos/pulp_white.svg';
import { type RadixTextSize } from '@/components/common/RadixProps';
import { cn } from '@/lib/utils';

interface PulpLogoProps {
  className?: string;
  size?: RadixTextSize;
  variant?: 'simple' | 'dot';
  width?: number;
  style?: React.CSSProperties;
}

/** v90 splash brand mark — pulsing orange dot + pulp wordmark. */
export function PulpLogo({ className, size, variant = 'dot', width, style }: PulpLogoProps) {
  const space = size ? `var(--space-${size})` : `${width}vw`;
  const scaled = space ? ({ width: space, gap: `calc(${space} * 0.1)` } as const) : undefined;

  const logoFile = pulpWhiteLogo;

  const showDot = variant == 'dot';
  return (
    <div className={cn('pulp-splash', className)} style={{ ...scaled, ...style }}>
      {showDot && (
        <span
          className="pulp-splash-dot"
          aria-hidden
          style={
            space ? { width: `calc(${space} * 0.1)`, height: `calc(${space} * 0.1)` } : undefined
          }
        />
      )}
      <img
        className="pulp-logo"
        src={logoFile}
        alt="pulp"
        style={size ? { width: '100%', maxWidth: 'none' } : undefined}
      />
    </div>
  );
}
